module.exports = __webpack_public_path__ + "img/Newsroom.cc1b15e1.jpg";